/**
 * @generated SignedSource<<e8a7ae0124e3711233556a6b9548d97c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionTopHomeV2Query$data = {
  readonly chinaSectionV2: {
    readonly name: string;
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2QueueItemsEdge">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly topStories: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId?: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetHomeV2Queue" | "twoSectionTopWidgetHomeV2Queue">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2Section">;
  };
  readonly hongKongSectionV2?: {
    readonly name: string;
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2QueueItemsEdge">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly topStories: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId?: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetHomeV2Queue" | "twoSectionTopWidgetHomeV2Queue">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2Section">;
  };
  readonly lifestyleSectionV2: {
    readonly name: string;
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2QueueItemsEdge">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly topStories: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId?: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetHomeV2Queue" | "twoSectionTopWidgetHomeV2Queue">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2Section">;
  };
  readonly peopleCultureSectionV2?: {
    readonly name: string;
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2QueueItemsEdge">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly topStories: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId?: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetHomeV2Queue" | "twoSectionTopWidgetHomeV2Queue">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2Section">;
  };
  readonly styleSectionV2: {
    readonly name: string;
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2QueueItemsEdge">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly topStories: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId?: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetHomeV2Queue" | "twoSectionTopWidgetHomeV2Queue">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2Section">;
  };
  readonly twiaSectionV2?: {
    readonly name: string;
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2QueueItemsEdge">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly topStories: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId?: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetHomeV2Queue" | "twoSectionTopWidgetHomeV2Queue">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2Section">;
  };
  readonly wellnessSectionV2?: {
    readonly name: string;
    readonly subSections: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2QueueItemsEdge">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly topStories: {
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly entityId?: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetHomeV2Queue" | "twoSectionTopWidgetHomeV2Queue">;
        }>;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"headerSectionTopHomeV2Section">;
  };
  readonly " $fragmentType": "sectionTopHomeV2Query";
};
export type sectionTopHomeV2Query$key = {
  readonly " $data"?: sectionTopHomeV2Query$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionTopHomeV2Query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "headerSectionTopHomeV2QueueItemsEdge"
      }
    ],
    "storageKey": null
  }
],
v2 = {
  "kind": "Literal",
  "name": "first",
  "value": 7
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Queue",
  "kind": "LinkedField",
  "name": "topStories",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityIds",
              "variableName": "excludeSsrContentEntityIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "exclude"
        },
        (v2/*: any*/)
      ],
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "entityId",
                      "storageKey": null
                    }
                  ],
                  "type": "Content",
                  "abstractKey": "__isContent"
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "oneSectionTopWidgetHomeV2Queue"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "twoSectionTopWidgetHomeV2Queue"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "headerSectionTopHomeV2Section"
},
v5 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Queue",
    "kind": "LinkedField",
    "name": "subSections",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 5
          }
        ],
        "concreteType": "QueueItemConnection",
        "kind": "LinkedField",
        "name": "items",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "items(first:5)"
      }
    ],
    "storageKey": null
  },
  (v3/*: any*/),
  (v4/*: any*/)
],
v6 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Queue",
    "kind": "LinkedField",
    "name": "subSections",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 6
          }
        ],
        "concreteType": "QueueItemConnection",
        "kind": "LinkedField",
        "name": "items",
        "plural": false,
        "selections": (v1/*: any*/),
        "storageKey": "items(first:6)"
      }
    ],
    "storageKey": null
  },
  (v3/*: any*/),
  (v4/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeSsrContentEntityIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isAsiaEdition"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isHongKongEdition"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "sectionTopHomeV2Query",
  "selections": [
    {
      "alias": "chinaSectionV2",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "4"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": (v5/*: any*/),
      "storageKey": "section(filter:{\"entityId\":\"4\"})"
    },
    {
      "condition": "isAsiaEdition",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "hongKongSectionV2",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "entityId": "2"
              }
            }
          ],
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": "section(filter:{\"entityId\":\"2\"})"
        }
      ]
    },
    {
      "alias": "lifestyleSectionV2",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "94"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "subSections",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 4
                }
              ],
              "concreteType": "QueueItemConnection",
              "kind": "LinkedField",
              "name": "items",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": "items(first:4)"
            }
          ],
          "storageKey": null
        },
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": "section(filter:{\"entityId\":\"94\"})"
    },
    {
      "condition": "isHongKongEdition",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "alias": "peopleCultureSectionV2",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "entityId": "318202"
              }
            }
          ],
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": "section(filter:{\"entityId\":\"318202\"})"
        }
      ]
    },
    {
      "condition": "isHongKongEdition",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "wellnessSectionV2",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "entityId": "24"
              }
            }
          ],
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": (v5/*: any*/),
          "storageKey": "section(filter:{\"entityId\":\"24\"})"
        }
      ]
    },
    {
      "alias": "styleSectionV2",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "72"
          }
        }
      ],
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "section",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Queue",
          "kind": "LinkedField",
          "name": "subSections",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": [
                (v2/*: any*/)
              ],
              "concreteType": "QueueItemConnection",
              "kind": "LinkedField",
              "name": "items",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": "items(first:7)"
            }
          ],
          "storageKey": null
        },
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": "section(filter:{\"entityId\":\"72\"})"
    },
    {
      "condition": "isAsiaEdition",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "twiaSectionV2",
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "entityId": "323045"
              }
            }
          ],
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": (v6/*: any*/),
          "storageKey": "section(filter:{\"entityId\":\"323045\"})"
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "72ad182538c4b734122fbdf700ecead8";

export default node;
